<template>
    <div class="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gradient-to-b from-pitch-purple to-dark-pitch-purple font-sans">
        <div>
            <Link href="/">
                <BreezeApplicationLogo />
            </Link>
        </div>

        <div class="w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg">
            <slot />
        </div>
    </div>
</template>

<script>
import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue'
import { Link } from '@inertiajs/vue3';

export default {
    components: {
        BreezeApplicationLogo,
        Link,
    }
}
</script>
